<template>
  <div class="header">
    <div class="header-title ml-4">
      <h1>{{ $route.meta.title }}</h1>
    </div>
    <div class="header-user">
      ADMINISTRADOR
      <b-button @click="logout" size="sm">Sair</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminHeader",
  data() {
    return {
      items: [
        { title: "Início", name: "inicio", icon: "home" },
        { title: "Usuário", name: "usuario", icon: "users" },
        { title: "Profissões", name: "profissao", icon: "briefcase" },
        { title: "Cargos", name: "cargos", icon: "user" },
        { title: "Departamentos", name: "departamentos", icon: "building" },
        { title: "Motivos bloqueio", name: "motivos_bloqueio", icon: "ban" }
      ]
    };
  },
  methods: {
    logout() {
      localStorage.apiToken = "";
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style lang="css" scoped>
.header {
  display: flex;
  justify-content: space-between;
  height: 70px;
  background: #fff;
  color: #6f6f6f;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}

.header-title {
  display: flex;
  align-items: center;
}

.header-title h1 {
  font-size: 16px;
  font-weight: normal;
  margin: 0;
}
.header-user {
  display: flex;
  align-items: center;
  font-size: 0.8em;
  color: #222;
  padding: 0 15px 0 10px;
}
.header-user button {
  margin: 0 1em;
}
</style>
